import { type ChipTone, StatusChip } from "@/components/shared/status-chip";
import { ACCESS_LEVEL_OPTIONS, type AccessLevel } from "@/lib/enums";

const TONES = {
  admin: "info",
  full: "neutral",
  aggregate: "neutral",
} as const satisfies Record<AccessLevel, ChipTone>;

export function AccessLevelBadge({ level }: { level: AccessLevel }) {
  const label = ACCESS_LEVEL_OPTIONS.find((o) => o.value === level)?.label ?? level;
  return <StatusChip tone={TONES[level]}>{label}</StatusChip>;
}
